// extracted by mini-css-extract-plugin
export default {"main":"blogPost_main__Ado2O","logoTitle":"blogPost_logoTitle__T3NKc","gameDesc":"blogPost_gameDesc__xasu1","gameSlider":"blogPost_gameSlider__AZ3pL","slide":"blogPost_slide__Ryzte"};